import $ from 'jquery';
import "flexslider";


$(document).ready(function() {
    
    function initimmolistslider() {
        $('.immoslider').flexslider({
            animation: "slide",
            controlNav: false,
            touch: true,
            slideshow: false,
            start: function(item){
                slideCounter(item);
            },
            after: function(item){
                slideCounter(item);
            }
        });
    }

    function slideCounter(item){
        var $sliderItemTotal =  item.find('.slider-item-total');
        var $sliderItemCurrent =  item.find('.slider-item-current');
        $sliderItemCurrent.text(item.currentSlide + 1);
        $sliderItemTotal.text(item.find('.slides').find('li:not(.clone)').length);
    }

    function immolistFilterChange() {
        let district = '';
        let baseRentMax = '';
        let livingSpaceMax = '';
        let numberOfRoomsMax = '';
        if($('#filterStadtteil').length) {
            district = $('#filterStadtteil').val();
        }
        if($('#filterKaltmiete').length) {
            baseRentMax = $('#filterKaltmiete').val();
        }
        if($('#filterWohnfläche').length) {
            livingSpaceMax = $('#filterWohnfläche').val();
        }
        if($('#filterZimmerzahl').length) {
            numberOfRoomsMax = $('#filterZimmerzahl').val();
        }

        const pageId = $('#pageid').data('pageid');
        const form = new FormData();
        form.append("tx_uoimmo_uoimmo[__referrer][@extension]", 'UoImmo');
        form.append("tx_uoimmo_uoimmo[__referrer][@controller]", 'RealEstates');
        form.append("tx_uoimmo_uoimmo[__referrer][@action]", 'list');
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId+ "][realEstateType]", 'apartmentRent');
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId+ "][apartmentRent][district]", district);
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId+ "][apartmentRent][baseRentMax]", baseRentMax);
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId+ "][apartmentRent][livingSpaceMax]", livingSpaceMax);
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId+ "][apartmentRent][numberOfRoomsMax]", numberOfRoomsMax);

        $.ajax({
            url: '?tx_uoimmo_uoimmo[action]=list&tx_uoimmo_uoimmo[controller]=RealEstates',
            data: form,
            method: 'POST',
            processData: false,
            contentType: false,
            success: function(data) {
                if($(data).find('.section-immolist #listenansicht').length && $('.section-immolist #listenansicht').length) {
                    $('.section-immolist #listenansicht').html($(data).find('.section-immolist #listenansicht').html());
                    if( $('.immoslider').length) {
                        initimmolistslider();
                    }
                    $('.realestate-count').html($('.immocard').length + ' Treffer');

                    window.immolistmap();
                }
            },
        });
    }

    if( $('.immoslider').length) {
        initimmolistslider();
    }
    
    if($('#filterStadtteil, #filterKaltmiete, #filterWohnfläche, #filterZimmerzahl').length) {
        $('body').on("change", '#filterStadtteil, #filterKaltmiete, #filterWohnfläche, #filterZimmerzahl', function(e) {
            immolistFilterChange();
        });
    }
}); 


function createMarkers(markersToCreate) {
    if(markersToCreate.length > 0) {
        let element = markersToCreate[0];
        let infowindow = null;
        let infoText = '';
        let marker = null;

        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': element.address + ', ' + element.strasse + ', Germany' }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                marker = new google.maps.Marker({
                    map: immolistmapObject,
                    position: results[0].geometry.location,
                    labelOrigin: new google.maps.Point(0, 0),
                });

                window.myLatLng.push(new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()));

                infoText = '<div class="g-map-bubble"><ul><li>' + element.titel + '</li><li>' + element.strasse + '<br/>' + element.address + '</li><li>Kaltmiete: ' + element.miete +
                            '</li><li>Wohnfläche: ' + element.qm + '</li><li>Zimmer: ' + element.zimmer + 
                            '</li><li><a class="btn btn-outline-primary" href="' + element.detailpage + '">Details</a></li></div>';

                infowindow = new google.maps.InfoWindow({
                    content: infoText
                });

                google.maps.event.addListener(marker, 'click', function () {
                    infowindow.open(immolistmapObject, marker);
                });

            } else {
                console.log("Geocode was not successful for the following reason: " + status);
            }


            markersToCreate.shift();
                if(markersToCreate.length > 0) {
                    setTimeout(() => {
                        createMarkers(markersToCreate);
                    }, 250);
                }
                else {
                    let bounds = new google.maps.LatLngBounds();
                    for ( var i = 0; i < window.myLatLng.length; i++ ) {
                        bounds.extend(window.myLatLng[i]);
                    }
                    immolistmapObject.fitBounds(bounds);
                    immolistmapObject.setCenter(bounds.getCenter());
                }
        });
    }
}

window.immolistmap = function() {
    window.immolistmapObject = new google.maps.Map(document.getElementById('immolistmap'), {
      zoom: 13,
      scrollwheel:  false,
      center: new google.maps.LatLng(document.getElementById('immolistmap').getAttribute('data-lng'), document.getElementById('immolistmap').getAttribute('data-lat')),
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: 
        [
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": "50"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "-13"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "20"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "-21"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "30"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": "-54"
                    },
                    {
                        "lightness": "35"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ]
    });

    let markersToCreate = []; 
    window.myLatLng = [];
    $('.listitem').each(function() {
        $this = $(this);

        markersToCreate.push({
            titel: $this.data('title'),
            strasse: $this.data('street'),
            address: $this.data('address'),
            miete: $this.data('miete'),
            qm: $this.data('qm'),
            zimmer: $this.data('zimmer'),
            detailpage: $this.data('detail'),
        });
    });
    
    createMarkers(markersToCreate);
}